module.exports = __webpack_public_path__ + "img/Vigna_radiata.0c3c5390.jpg";